export enum Collection {
  USERS = 'users',
  REMOLQUES = 'remolques',
  ESTADOS = 'estados',
  MATRICULAS = 'matriculas',
  ARMADOS = 'armados'
}
